module.exports = __webpack_public_path__ + "rotary_right.svg?a1bd4d2d0ac422b59e086419ac39a158";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/rotary_right.svg
// module id = 209
// module chunks = 0